import { INotificationParameter } from "./notification-parameter";
import { INotificationSubscription } from "./notification-subscription";

/** Тип канала достаки уведомлений. */
export enum NotificationChannelType {
    /** Телеграм-бот. */
    TelegramCustomBot = "telegram-custom-bot",
}

/** Канал доставки уведомлений. */
export interface INotificationChannel {
    id: string;

    /** Идентификатор компании, по которой будут приходить уведомления. */
    companyId: string;
    
    /** Идентификатор пользователя, которому будут приходить уведомления. */
    userId?: string;

    /** Тип канала. */
    type: NotificationChannelType;

    /** Название. */
    name: string;

    /** Открытый ключ (например, id пользователя в Телеграме). */
    key?: string;

    /** Секретный ключ (например, токен Телеграм-бота). Хранится в зашифрованном виде. */
    secret?: string;

    // /** Объект с открытыми данными (например, id пользователя в Телеграме). */
    // data?: Record<string, any>;

    // /** Объект с секретными данными, которые хранятся в зашифрованном виде (например, токен Телеграм-бота). */
    // secrets?: Record<string, any>;

    /** Служебные данные, необходимые для отправки уведомлений. */
    internal?: INotificationParameter[];
    
    /** Уведомления, которые надо отправлять в данный канал. */
    subscriptions: INotificationSubscription[];

    /** Канал выключён (уведомления не отправляются). */
    disabled?: boolean;

    createdAt: Date;
    updatedAt: Date;
}
